export default {
  providerId: state => state.providerId,
  stableCoins: state => state.stableCoins,
};
